import { ShieldCheck, FileCheck2, Truck, GraduationCap } from "lucide-react";

const BADGES = [
  { icon: ShieldCheck, title: "Lawfully Supplied", sub: "Research & educational use" },
  { icon: FileCheck2, title: "Documented Batches", sub: "References where available" },
  { icon: Truck, title: "UK Dispatch", sub: "Tracked, discreet packaging" },
  { icon: GraduationCap, title: "Built for Precision", sub: "Clear, honest specifications" },
];

export const TrustBadges = () => (
  <div className="grid grid-cols-2 gap-6 rounded-3xl bg-white p-6 shadow-[0_30px_80px_-30px_rgba(15,23,42,0.4)] ring-1 ring-slate-100 sm:p-8 lg:grid-cols-4">
    {BADGES.map((b) => (
      <div key={b.title} className="flex items-center gap-3">
        <span className="grid h-11 w-11 shrink-0 place-items-center rounded-xl bg-blue-50 text-blue-600">
          <b.icon className="h-5 w-5" />
        </span>
        <div>
          <p className="text-sm font-semibold text-slate-900">{b.title}</p>
          <p className="text-xs text-slate-500">{b.sub}</p>
        </div>
      </div>
    ))}
  </div>
);

export default TrustBadges;
